module.exports = __webpack_public_path__ + "static/honeywell-b53ffdcc35a417c645fe717a6c22098a.png";